const zhCN = {
  getOrgFail: '获取组织信息失败！',
  listBtnEdit: '编辑',
  listBtnQRCode: '二维码',

  listUpOrg: '上级组织',
  listOrgName: '组织名称',
  listRemark: '备注',
  listOperation: '操作',

  newOrg: '新增组织',
  editOrg: '编辑组织',

  orgName: '组织名称',
  orgNameBlank: '请填写组织名称！',
  orgNameWarning: '组织名称最多20字',
  remark: '备注',

  orgQRCode: '组织二维码',
  QRCodeValidity: '二维码有效期',
  QRCodeLongTerm: '长期有效',
  QRCodeUserDefined: '自定义',
  QRCodeExpiryTime: '失效时间',
  QRCodeExpiryTimeTxt: '二维码失效时间',
  QRCodeExpiryTimeBlank: '请设置二维码失效时间',

  setQRCodeValidityFail: '设置二维码有效时间失败！',

  QRCodeUseDesc: '扫描二维码通过身份验证后，即可绑定访客微信小程序，邀请访客！',
  QRCodeValidityDesc: '组织二维码长期有效！',
  QRCodeExpiryTimeDesc: '组织二维码有效期至',

  QRCodeApplyDesc: '访客通过扫描二维码，进入微信小程序，申请访问！',

  submitBtn: '提交',
  confirmBtn: '确定',
  cancelBtn: '取消',

  submitRequestSuccess: '提交组织信息成功！',
  submitRequestFail: '提交组织信息失败！',

  deleteOrgBtn: '删除',
  deleteWarning: '您确定要删除选中组织？',
  deleteWarningDesc: 'return "当前共选中 " + count + " 个组织。"',

  deleteFail: '删除失败',
  batchDeleteSuccess: 'return "成功删除 " + count + " 个组织！"',
  batchDeleteFail: 'return "删除失败 " + count + " 个组织！"'

}
const enUS = {
  getOrgFail: 'Request organization info failed',
  listBtnEdit: 'Edit',
  listBtnQRCode: 'QR code',

  listUpOrg: 'Superior',
  listOrgName: 'Organization',
  listRemark: 'Remark',
  listOperation: 'Operation',

  newOrg: 'Add',
  editOrg: 'Edit',

  orgName: 'Organization',
  orgNameBlank: 'Organization can\'t be blank!',
  orgNameWarning: 'Organization is up to 20 words!',
  remark: 'Remark',

  orgQRCode: 'Organization QR code',
  QRCodeValidity: 'QR code Validity',
  QRCodeLongTerm: 'long-term',
  QRCodeUserDefined: 'user-defined',
  QRCodeExpiryTime: 'Expiry Time',
  QRCodeExpiryTimeTxt: 'Expiry time of QR code',
  QRCodeExpiryTimeBlank: 'Expiry time can\'t be blank!',

  setQRCodeValidityFail: 'Fail to Set valid time of QR code!',

  QRCodeUseDesc: 'After scans the QR code to pass the authentication, can bind the visitor WeChat mini-program and invites the visitor!',
  QRCodeValidityDesc: 'QR code of organization is long-term effective!',
  QRCodeExpiryTimeDesc: 'QR code of organization is valid until',

  submitBtn: 'Submit',
  confirmBtn: 'Confirm',
  cancelBtn: 'Cancel',

  submitRequestSuccess: 'Submit organization info successfully!',
  submitRequestFail: 'Submit organization info failed!',

  deleteOrgBtn: 'Delete',
  deleteWarning: 'Are you sure to delete the selected organizations?',
  deleteWarningDesc: 'return count + " organizations are selected."',

  deleteFail: 'Delete failed!',
  batchDeleteSuccess: 'return "Delete " + count + " organizations successfully!"',
  batchDeleteFail: 'return "Delete " + count + " organizations failed!"'

}

export default { zhCN, enUS }
